<template>
	<div id="content" class="content payment">
		<div class="container">
			<!-- 페이지 타이틀 -->
			<div class="page-title">
				<h2 class="tit">구매하기</h2>
			</div>

		<order-product :produc-list="producList" :total-cost="totalCost" :selected-option-details="selectedOptionDetails"></order-product>

		<order-form :order-info="orderInfo" :total-cost="totalCost" :is-license-order="isLicenseOrder" :license-product-list="licenseProductList" :order-product-list="orderProductList" :selected-option-details="selectedOptionDetails" :produc-list="producList"></order-form>

		</div>
	</div>
</template>
<script>
import OrderForm from "@/components/shop/order/orderForm";
import OrderProduct from "@/components/shop/order/orderProduct"
export default {
	name: "orderInfo",
	components: {OrderForm, OrderProduct},
	data() {
		var params = this.pageUtils.Params()
		return {
			params,
			producList: [],
			totalCost: 0,
			selectedOptionDetails: [], // 선택 옵션 상세 목록 (orderProduct 표시·주문 전달용)

			orderInfo: new this.OrderInfoVO( this.getSessionProc() ),
			isLicenseOrder: false,
			licenseProductList: [],
			orderProductList: [],
		}
	},
	async created() {
		if(!this.isLogin())
			await !this.requireLogin(this, false)
		this.getProducts();
	},
	mounted() {
		this.getCoAccount();
	},
	methods: {

		getProducts() {
			console.log(this.productList)
			this.axiosCaller.get(this, this.APIs.SHOP_GOODS + "/getOrderProdc", {
				cidxs: this.$route.query.cidxs,
				gidx: this.$route.query.gidx,
			}, (res) => {
				if (res.data.status === "ok") {
					const singleCount = this.$route.query.count ? parseInt(this.$route.query.count, 10) : 1;
					if (this.$route.query.cidxs !== undefined) {
						this.producList = res.data.producList;
						this.totalCost = res.data.total;
						this.selectedOptionDetails = [];
					} else if (this.$route.query.gidx !== undefined) {
						this.producList = res.data.producList;
						const basePrice = res.data.producList[0].basePrice;
						const count = singleCount;
						const optionDetailIds = (this.$route.query.optionDetailIds || '').toString().split(',').filter(Boolean).map(id => parseInt(id, 10));
						if (optionDetailIds.length > 0) {
							this.fetchOptionsAndSetTotal(this.$route.query.gidx, basePrice, count, optionDetailIds);
						} else {
							this.totalCost = basePrice * count;
							this.selectedOptionDetails = [];
						}
					}
					// 단일상품+옵션 없음: fetchOptionsAndSetTotal 호출 안 함 → 여기서 빌드
					if (this.$route.query.gidx && (!this.$route.query.optionDetailIds || (this.$route.query.optionDetailIds || '').toString().trim() === '')) {
						this.buildOrderProductList(singleCount);
					} else if (this.$route.query.cidxs !== undefined) {
						// 장바구니: 여기서 빌드 (producList에 licenseTermMonths 포함됨)
						this.buildOrderProductList(singleCount);
					}
					// 장바구니/상품상세 공통: 라이선스 상품 여부 확인
					this.checkLicenseProduct(this.producList);
				} else {
					this.swalUtils.gritter("Error", res.msg, "error")
							.then(() => {
								if (document.location.href === document.referrer || document.referrer.indexOf("order_done") !== -1)
									location.href = "app/shop/goods";
								else
									location.href = document.referrer
							})
				}
			});
		},

		/** gidx 단일상품 주문 시 선택 옵션 조회 후 총액·선택옵션목록 설정 */
		fetchOptionsAndSetTotal(gidx, basePrice, count, optionDetailIds) {
			this.axiosCaller.get(this, this.APIs.SHOP_GOODS + "/" + gidx + "/options", {}, (res) => {
				if (res.data.status !== "ok" || !res.data.list) {
					this.totalCost = basePrice * count;
					this.selectedOptionDetails = [];
					this.buildOrderProductList(count);
					return;
				}
				const idSet = new Set(optionDetailIds);
				let optionPriceSum = 0;
				const details = [];
				res.data.list.forEach(group => {
					(group.optionDetails || []).forEach(d => {
						if (idSet.has(d.id)) {
							optionPriceSum += Number(d.optionPrice) || 0;
							details.push({ id: d.id, optionName: d.optionName, optionPrice: d.optionPrice, licenseTermMonths: d.licenseTermMonths });
						}
					});
				});
				this.totalCost = (basePrice + optionPriceSum) * count;
				this.selectedOptionDetails = details;
				this.buildOrderProductList(count);
			});
		},
		/** producList + selectedOptionDetails 기반으로 orderProductList 생성 */
		buildOrderProductList(singleCount) {
			const count = singleCount != null ? singleCount : (this.$route.query.count ? parseInt(this.$route.query.count, 10) : 1);
			const optionIdsForGidx = this.$route.query.optionDetailIds
				? (Array.isArray(this.$route.query.optionDetailIds) ? this.$route.query.optionDetailIds.join(',') : String(this.$route.query.optionDetailIds))
				: null;
			const licenseTermForItem = (item) => {
				if (item.licenseTermMonths != null && item.licenseTermMonths > 0) return item.licenseTermMonths;
				if (this.selectedOptionDetails && this.selectedOptionDetails.length > 0) {
					const d = this.selectedOptionDetails.find(s => s.licenseTermMonths != null && s.licenseTermMonths > 0);
					return d ? d.licenseTermMonths : null;
				}
				return null;
			};
			const optionSummaryForItem = (item) => {
				if (item.optionSummary) return item.optionSummary;
				if (this.selectedOptionDetails && this.selectedOptionDetails.length > 0) {
					return this.selectedOptionDetails.map(d => d.optionName).join(', ');
				}
				return null;
			};
			this.orderProductList = (this.producList || []).map(item => ({
				gid: item.gid,
				quantity: item.count != null ? item.count : count,
				optionIds: item.optionIds != null ? item.optionIds : (this.$route.query.gidx ? optionIdsForGidx : null),
				licenseTermMonths: licenseTermForItem(item),
				optionSummary: optionSummaryForItem(item)
			}));
		},

		/**
		 * productList: CartVO[] 또는 GoodsVO[] (공통 필드 gid 사용)
		 * 장바구니: item.gid, item.count / 상품상세: item.gid, 수량은 query.count
		 */
		checkLicenseProduct(productList) {
			if (!productList || productList.length === 0) {
				this.isLicenseOrder = false;
				this.licenseProductList = [];
				return;
			}
			const gids = productList.map(item => item.gid).filter(g => g != null);
			if (gids.length === 0) {
				this.isLicenseOrder = false;
				this.licenseProductList = [];
				return;
			}
			this.axiosCaller.get(this, this.APIs.SHOP_GOODS + "/checkLicenseByGids", {
				gids: gids.join(",")
			}, (res) => {
				if (res.data.status !== "ok" || !res.data.licenseGids || res.data.licenseGids.length === 0) {
					this.isLicenseOrder = false;
					this.licenseProductList = [];
					return;
				}
				const licenseGidSet = new Set(res.data.licenseGids);
				const singleProductCount = this.$route.query.count ? parseInt(this.$route.query.count, 10) : 1;
				this.licenseProductList = productList
					.filter(item => licenseGidSet.has(item.gid))
					.map(item => ({
						gid: item.gid,
						quantity: item.count != null ? item.count : singleProductCount
					}));
				this.isLicenseOrder = this.licenseProductList.length > 0;
			});
		},

		getCoAccount() {
			var orderInfo = this.orderInfo;
			this.$eventBus.$emit("startProgress")
			this.axiosCaller.get( this, this.APIs.CO_ACCOUNT + "/", {
				coCode: this.webUtils.getSubdomain(),
				coEmailId: this.getSessionProc().coEmailId,
			}, (res) => {
				this.$eventBus.$emit("doneProgress")
				const result = res.data
				// console.log('result.coAccountVO',result.coAccountVO)
				orderInfo.deliveryReceiverPhone = result.coAccountVO.phone;
				orderInfo.orderName = result.coAccountVO.userName;
				orderInfo.deliveryReceiverName = result.coAccountVO.userName;
				orderInfo.email = result.coAccountVO.coEmailId;
			})

		},
	},

}
</script>

<style scoped>

</style>
